export default "__VITE_ASSET__BV$Eh0HS__"